__turbopack_context__.v({
  "marqueeContainer": "f6P_ga_marqueeContainer",
  "marqueeContent": "f6P_ga_marqueeContent",
  "marqueeItem": "f6P_ga_marqueeItem",
  "scrollUp": "f6P_ga_scrollUp",
});
